import { PlanViewKey } from "../hooks/useQueryParams";
import { AppDispatch } from "../store";
import {
  cancelDrag,
  setActiveSessionStatus,
  setSessionStatus,
} from "../store/dragAndDrop";
import { getGanttChartData } from "../store/ganttChart/action";
import { getKPICollection } from "../store/KPICollection/action";
import { PlanViewStateEntry } from "../store/realTimeUpdates";
import { GanttChartData } from "../types/ganttChart";
import DragAndDropService from "./dragAndDrop";

export const fetchData = async (
  dispatch: AppDispatch,
  planViewState: PlanViewStateEntry,
  queryObject: PlanViewKey,
  activeDragAndDropSession: boolean,
  dataToUse?: GanttChartData,
) => {
  if (queryObject.solutionType !== "CustomSolution") {
    dispatch(getGanttChartData(queryObject));
    dispatch(getKPICollection(planViewState));
    dispatch(cancelDrag());
  } else if (
    queryObject.solutionType === "CustomSolution" &&
    !activeDragAndDropSession &&
    dataToUse
  ) {
    dispatch(setSessionStatus(true));
    try {
      await DragAndDropService.initiateSessionAndStoreData(dataToUse, dispatch);
    } catch (error) {
      /* TODO: add error handling */
    }
  } else if (
    queryObject.solutionType === "CustomSolution" &&
    activeDragAndDropSession
  ) {
    const result = await DragAndDropService.getCustomSessionState(dispatch);
    if (result.data) dispatch(setActiveSessionStatus(result.data));
  }
};
